"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoctorsHttpService = void 0;
const get_doctor_list_1 = require("../../types/doctors/get-doctor-list");
const http_service_1 = require("../http.service");
class DoctorsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/doctors`);
    }
    getList(payload) {
        const params = {
            ...payload,
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        return this.getEntityList('', {
            params,
            schema: get_doctor_list_1.getDoctorsListApiResponseSchema,
        });
    }
}
exports.DoctorsHttpService = DoctorsHttpService;
